import { AllChangeEvent, useCallback } from 'react';

import { Row, LabeledInput } from 'components/Blocks';

import { ProjectTypeProps } from '.';

import { useLang } from 'hooks/lang';
import { CircleSlashIcon, WavesIcon } from 'components/Icons';

const validations: Record<string, RegExp> = {
  waves: /^[1-9]\d*$/,
  shadowBanInWaves: /^[0-9]\d*$/,
};

export function TrackerOrigin({ projectType, dispatch }: ProjectTypeProps): JSX.Element {
  const { t } = useLang();

  const { waves, shadowBanInWaves } = projectType;

  const handleChange = useCallback(
    ({ target }: AllChangeEvent) => {
      const { value, id } = target;

      if (!validations[id].test(value)) return;

      dispatch({
        typeConfig: (old) => ({
          ...old.typeConfig,
          [id]: Number(value),
        }),
      });
    },
    [dispatch],
  );

  return (
    <Row>
      <LabeledInput
        containerClassName="w-full"
        id="waves"
        type="number"
        value={typeof waves !== 'number' ? '' : `${waves}`}
        onChange={handleChange}
        labelIcon={WavesIcon}
        label={t('number-of-waves')}
      />

      <LabeledInput
        containerClassName="w-full"
        id="shadowBanInWaves"
        type="number"
        value={typeof shadowBanInWaves !== 'number' ? '' : `${shadowBanInWaves}`}
        onChange={handleChange}
        labelIcon={CircleSlashIcon}
        label={`${t('exclude-time')} (${t('in-waves')})`}
      />
    </Row>
  );
}
